import { render } from "./PersonaUsuarioReg.vue?vue&type=template&id=feb3da12"
import script from "./PersonaUsuarioReg.vue?vue&type=script&lang=js"
export * from "./PersonaUsuarioReg.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__